import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NavLabelComponent } from '../../nav-label/nav-label.component';
import { NavigationNode } from '@spartacus/storefront';

@Component({
  selector: 'content-2-levels',
  standalone: true,
  imports: [CommonModule, NavLabelComponent],
  templateUrl: './content-2-levels.component.html',
  styleUrl: './content-2-levels.component.scss',
})
export class Content2LevelsComponent {
  @Input() node!: NavigationNode;
}
